const ERRORS_TRANSLATIONS = {
  // 502: 'Пользователь не найден, проверьте правильность ввода номера телефона.',
  // 518: 'Вы не можете восстановить пароль, т.к. вам недоступно участие в акции.',
  // 523: 'Ваша анкета находится на рассмотрении, дождитесь окончания регистрации.'
}

export default errorValue => {
  let code = errorValue['code']
  if (code && Object.keys(ERRORS_TRANSLATIONS).indexOf(code.toString()) > -1) {
    return `${ERRORS_TRANSLATIONS[code]}`
  } else {
    return `${errorValue['message']}`
  }
}



// WEBPACK FOOTER //
// ./src/common/error.filter.js